import { render, staticRenderFns } from "./16_ap_identificadores.vue?vue&type=template&id=42fd5ce2&"
import script from "./16_ap_identificadores.vue?vue&type=script&lang=js&"
export * from "./16_ap_identificadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports